import { DispatchLegRaw, transformDispatchLegsResponse } from '@api/Trinium/Endpoints/Dispatch/types';

/**
 * Static rows backing the Board Query preview grid. Authored as raw API shapes and pushed through the real
 * transform so the parsed dates and trace values match what the board receives.
 */
const demoLegs: DispatchLegRaw[] = [
  {
    legId: -1,
    legNo: 1,
    legStatus: 'NA',
    legType: 'FCL',
    legPriority: 1,
    isActiveLeg: true,
    isLive: true,
    jobId: 900001,
    jobCat: 'IMP',
    jobCatTransType: 'I',
    jobDocDate: '2026-07-20T00:00:00',
    csnId: 800001,
    csnNo: 1,
    csnCustRefNo: 'REF-44821',
    csnNotes:
      'Receiver takes deliveries 7a-11a only, no exceptions. Gate pass required at guard shack - driver must show the release number. Empty returns to Maher, appointment needed.',
    csnLastFreeDate: '2026-08-03T00:00:00',
    cntrId: 'MSCU4471820',
    cntrSize: 40,
    cntrType: 'HC',
    cntrProviderId: 'MSC',
    cntrProviderName: 'Mediterranean Shipping',
    chassisId: 'TRAC 5591-8',
    isChassisOwned: true,
    custId: 'ACMEDIST',
    custName: 'Acme Distributing',
    drvId: 'D0417',
    drvName: 'J SMITH',
    drvType: 'D',
    tractorId: 'T-118',
    puId: 'APMT',
    puName: 'APM Terminals',
    puCity: 'Elizabeth',
    puState: 'NJ',
    puSealNo: 'SL8827431',
    delvId: 'ACMEWH1',
    delvName: 'Acme Warehouse 1',
    delvCity: 'Allentown',
    delvState: 'PA',
    schdPuFrom: '2026-07-29T08:00:00',
    schdPuTo: '2026-07-29T12:00:00',
    schdDelvFrom: '2026-07-30T07:00:00',
    schdDelvTo: '2026-07-30T11:00:00',
    dehireId: 'MAHER',
    dehireName: 'Maher Terminals',
    dehireCity: 'Elizabeth',
    dehireState: 'NJ',
    bookingRefNo: 'BK-772104',
    masterBol: 'MSCUXY9930441',
    relNo: 'RL-30928',
    vslName: 'MSC AURORA',
    voyage: '241E',
    voyageEtaDate: '2026-07-26T00:00:00',
    fullAvailDate: '2026-07-27T00:00:00',
    emptyAvailDate: '2026-07-31T00:00:00',
    pcs: 1240,
    totWgt: 38400,
    wgtLb: 38400,
    hasNotes: true,
    isRailBilled: false,
    trcCntrAvail: 'Y',
    trcCntrStatus: 'DISCHARGED',
    trcCntrHolds: 'NONE',
    trcEvent: 'VESSEL DISCHARGE',
    trcEventState: 'COMPLETE',
    trcLocation: 'Elizabeth, NJ',
    trcLocalDateTime: '2026-07-26T14:35:00',
    trcETADate: '2026-07-26T00:00:00',
    trcLFD: '2026-08-03',
    trcDestInfo: 'E-RAIL / NS Croxton',
    trcInvStatus: 'OPEN',
    trcResult: 'OK'
  },
  {
    legId: -2,
    legNo: 2,
    legStatus: 'AV',
    legType: 'ECL',
    legPriority: 2,
    isActiveLeg: true,
    isHazmat: true,
    reqHazmatCert: true,
    jobId: 900002,
    jobCat: 'EXP',
    jobCatTransType: 'E',
    jobDocDate: '2026-07-22T00:00:00',
    csnId: 800002,
    csnNo: 2,
    csnCustRefNo: 'PO-99120',
    csnNotes: 'Cutoff is firm - do not schedule after 3pm.',
    csnCutoffDate: '2026-08-01T17:00:00',
    cntrId: 'TCLU8830917',
    cntrSize: 20,
    cntrType: 'DV',
    cntrProviderId: 'ONE',
    cntrProviderName: 'Ocean Network Express',
    chassisId: 'FLEX 2210-4',
    custId: 'NORTHCHEM',
    custName: 'Northeast Chemical',
    drvId: 'D0288',
    drvName: 'R JONES',
    drvType: 'B',
    tractorId: 'T-204',
    puId: 'NORTHCHEM',
    puName: 'Northeast Chemical Plant',
    puCity: 'Bethlehem',
    puState: 'PA',
    delvId: 'PNCT',
    delvName: 'Port Newark Container Terminal',
    delvCity: 'Newark',
    delvState: 'NJ',
    schdPuFrom: '2026-07-30T13:00:00',
    schdPuTo: '2026-07-30T16:00:00',
    schdDelvFrom: '2026-07-31T09:00:00',
    schdDelvTo: '2026-07-31T15:00:00',
    bookingRefNo: 'BK-880233',
    masterBol: 'ONEYXQ4471200',
    relNo: 'RL-31004',
    vslName: 'ONE MERIDIAN',
    voyage: '117W',
    voyageEtaDate: '2026-08-02T00:00:00',
    emptyAvailDate: '2026-07-28T00:00:00',
    pcs: 640,
    totWgt: 21750,
    wgtLb: 21750,
    isOverweight: false,
    isRailBilled: true,
    trcCntrAvail: 'N',
    trcCntrStatus: 'EMPTY OUT',
    trcCntrHolds: 'CUSTOMS',
    trcEvent: 'GATE OUT',
    trcEventState: 'PENDING',
    trcLocation: 'Newark, NJ',
    trcLocalDateTime: '2026-07-28T09:12:00',
    trcInvStatus: 'HOLD',
    trcResult: 'HOLD'
  },
  {
    legId: -3,
    legNo: 3,
    legStatus: 'DL',
    legType: 'BOB',
    legPriority: 0,
    isBulk: true,
    jobId: 900003,
    jobCat: 'LCL',
    jobCatTransType: 'L',
    jobDocDate: '2026-07-18T00:00:00',
    csnId: 800003,
    csnNo: 1,
    delvDate: '2026-07-24T15:40:00',
    custId: 'HARBORLOG',
    custName: 'Harbor Logistics',
    drvId: 'D0135',
    drvName: 'M DELGADO',
    drvType: 'T',
    tractorId: 'T-076',
    puId: 'HARBORYD',
    puName: 'Harbor Yard',
    puCity: 'Jersey City',
    puState: 'NJ',
    delvId: 'HARBORDC',
    delvName: 'Harbor Distribution Center',
    delvCity: 'Edison',
    delvState: 'NJ',
    puDate: '2026-07-24T08:05:00',
    masterBol: 'HLXX2201884',
    pcs: 18,
    totWgt: 4200,
    wgtLb: 4200,
    hasNotes: false,
    isRailBilled: false,
    trcResult: 'OK'
  }
];

export const previewRows = transformDispatchLegsResponse(demoLegs);
